module.exports = __webpack_public_path__ + "static/media/Club_green.83446f37.svg";